import { render, staticRenderFns } from "./Navigator.vue?vue&type=template&id=60793980&scoped=true"
import script from "./Navigator.vue?vue&type=script&lang=js"
export * from "./Navigator.vue?vue&type=script&lang=js"
import style0 from "./Navigator.vue?vue&type=style&index=0&id=60793980&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60793980",
  null
  
)

export default component.exports